import React from 'react';

import { createBrowserHistory } from 'history';
import { Router, Switch } from 'react-router-dom';
import { SnackbarWrapper } from 'utilitys/SnackbarWrapper';

import useUserHook from 'hooks/useUserHook';

import { useThemeStatusStore } from 'store/themeStatus.store';

import AuthenticateLayout from 'components/App/AuthenticateLayout/authenticateLayout';
import ProtectedRoute from 'components/App/routes/ProtectedRoute';
import { PublicRoutes } from 'components/App/routes/publicRoutes';

require('components/App/app.scss');

// ================ theme ====================================================================================
useThemeStatusStore.getState().themeStatus
    ? document?.querySelector('body')?.setAttribute('data-theme', 'dark')
    : document?.querySelector('body')?.setAttribute('data-theme', 'light');
// ===========================================================================================================

export const history = createBrowserHistory();

const App = () => {
    const { email } = useUserHook();
    const auth = Boolean(email);

    return (
        <Router history={history}>
            <SnackbarWrapper>
                <Switch>
                    {PublicRoutes()}
                    <ProtectedRoute path={'/'} auth={auth} component={AuthenticateLayout} />
                </Switch>
            </SnackbarWrapper>
        </Router>
    );
};

export default App;
